import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { PassengerItem } from 'entities/beket/components/my-order-passenger/index'

import { OrdersByIdBeket } from 'shared/api/beket/my-orders/model'
import { StatusPurchase, TariffBeket } from 'shared/constants'
import { previewPdfUrl } from 'shared/lib/pdf-preview'
import { Collapse } from 'shared/ui/collapse'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  orderInfo: OrdersByIdBeket
}

export const MyOrderPassenger = ({ orderInfo }: Props) => {
  const { t } = useTranslation()

  const isPaid = StatusPurchase.PAID.key === orderInfo.status

  const onShowPDFFile = () => {
    previewPdfUrl(orderInfo?.receipt_url)
  }

  return (
    <Paper padding={[16]}>
      <Collapse
        title={t('passengers')}
        alwaysOpen={false}
        count={orderInfo?.tickets.length}
      >
        <div className={s.itemsList}>
          {orderInfo?.tickets.map((item) => {
            const listNames = [
              {
                label: t('age_of_passenger'),
                value: t(TariffBeket?.[item.tariff as keyof Object].name),
              },
              {
                label: t('seat_number'),
                value: item?.seat_number,
              },
            ]

            return (
              <PassengerItem
                key={item?.id}
                isPaid={isPaid}
                qrCode={item.qr_code}
                listNames={listNames}
                tickerReceipt={item?.ticket_receipt_url}
                fullName={`${item?.last_name} ${item?.first_name}`}
              />
            )
          })}
        </div>
      </Collapse>

      {orderInfo?.receipt_url && (
        <p
          onClick={onShowPDFFile}
          className={clsx(s.link, 'medium-14')}
        >
          {t('beket.show_ticket')}
        </p>
      )}
    </Paper>
  )
}
